import { Injectable, OnDestroy } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { IDriver } from 'app/models/IDriver';
import { INascarViewModel } from 'app/models/INascarViewModel';
import { BaseService } from 'app/services/base.service';
import { IOrgRole } from '../models/IOrgRole';
import { IOrgRoleUser } from '../models/IOrgRoleUser';
import { IOrgUserRaceFilter } from '../models/IOrgUserRaceFilter'
import { IOrg } from '../models/IOrg';
import { ISeasonWeek } from '../models/ISeasonWeek';
import { IOrgSeasonWeek } from '../models/IOrgSeasonWeek';
import { IRace } from 'app/models/IRace';
import { IEntity } from 'app/models/IEntity';

@Injectable()
export class AdminService  {
    // public nascar: INascarViewModel;
    private convertModel(model: IOrgSeasonWeek) : ISeasonWeek {
        return {orgId: model.org.id, season: model.season.name, seasonType: model.seasonType, week: model.week.name, userId: model.userId} as ISeasonWeek;
    }
    constructor(private baseService: BaseService) {
    }
    
    ngOnDestroy() {
      //  this.baseService.sendHttpGet('/admin/updatecurrentnascarresult')
    }

    getOrgs() {
        return this.baseService.sendHttpGet('/admin/getOrgs');

    }

    getRoles() {
        return this.baseService.sendHttpGet('/admin/getRoles');

    }

    getUsersByOrgRole(orgRole: IOrgRole) {
        return this.baseService.sendHttpGet('/admin/getUsersByOrgRole', orgRole);
    }

    // geCurrentOrgUserRaceByUser(filter: IOrgRole) {
    //     return this.baseService.sendHttpPost('/admin/getcurrentorguserracebyuser', IOrgUserRaceFilter); 
    // }

    getNascarUsers() {
        return this.baseService.sendHttpGet('/nascar/getNascarUsers');

    }

    getNascarOrgUsers(org: IOrg) {
        return this.baseService.sendHttpPost('/nascar/getNascarOrgUsers', org);
    }

    getCurrentOrgUserRace() {
        return this.baseService.sendHttpGet('/nascar/currentorguserrace');
    }

    getRace(raceFilter: IOrgUserRaceFilter) {
        return this.baseService.sendHttpPost('/admin/getrace', raceFilter);
    }

    createOrg(org: IOrg) {
        return this.baseService.sendHttpPost('/admin/createOrg', org);
    }
    createNflSeasonWeek(model: IOrgSeasonWeek) {
        var result = this.convertModel(model);
        return this.baseService.sendHttpPost('/admin/createseasonweek', result);
    }

    getSeasonWeeks() {
        return this.baseService.sendHttpGet('/admin/getseasonweeks');
    }

    createOrgGames(seasonWeek: IOrgSeasonWeek, org: IOrg) {
        var result = this.convertModel(seasonWeek);
        return this.baseService.sendHttpPost('/admin/createorggames', { result, org })
    }


    getGames(model: IOrgSeasonWeek) {
        var result = this.convertModel(model);
        return this.baseService.sendHttpPost('/admin/getgames', result);
    }

    updateCurrentNascarResult() {
        return this.baseService.sendHttpGet('/admin/updatecurrentnascarresult').subscribe(result => {
            console.log(result);
        })
    }

    createRace(model: IRace) {
        return this.baseService.sendHttpPost('/admin/createrace', model);
    }

    upsertRace(model: IRace) {
        return this.baseService.sendHttpPost('/admin/upsertrace', model);
    }

    getUsersByOrg(org: IEntity) {
        return this.baseService.sendHttpGet('/admin/getusersbyorg', org)
    }


}


// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/services/admin.service.ts